import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import HorizontalForm from './components/ViewSku7MrpMaster';


const ViewSku7MrpMaster = ({ t }) => (
  <Container>
    <Row>
      <Col md={12}>
        <h3 className="page-title">SKU7 MRP EAN MASTER - View</h3>
      </Col>
    </Row>
   
    <Row>
      <HorizontalForm />
    </Row>

  </Container>
);

ViewSku7MrpMaster.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation('common')(ViewSku7MrpMaster);
